export default __webpack_public_path__ + "static/media/stickerLockStar.e767487f.png";